export default __webpack_public_path__ + "static/index-title-versions-zh-Hant-8c7ef803a21802258194d8a46d2eb2e6.png";